import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ModalService} from "../../services/modal.service";
import {AppMessage} from "../../definitions";
import {APP_MESSAGES} from "../../enums/enums";
import {ILocaleItem} from "../../components/nv-locale/nv-locale.component";
import {WatchService} from "../../services/watch.service";
declare const $: any;

@Component({
  selector: 'nv-locales-modal',
  templateUrl: './nv-locales-modal.component.html',
  styles: []
})
export class NvLocalesModalComponent implements OnInit {
  item: ILocaleItem;
  @ViewChild("modalRoot") element: ElementRef;

  LOCALE_NAMES = [
    "Именительный падеж, ед. ч. (один стол)",
    "Родительный падеж, ед. ч. (нет одного стола)",
    "Именительный падеж, мн. ч.  (нет двух столов)",
    "Именительный падеж, мн. ч. (нет пяти столов)"
  ];


  constructor(private modalService: ModalService,
              private watchService: WatchService) {
  }


  ngOnInit() {
    this.modalService.onModalRequest
      .subscribe(
        appMessage => this.handleRequest(appMessage));
  }


  onInputChange() {
    this.watchService.notify();
  }


  private handleRequest(appMessage: AppMessage) {
    if (appMessage.type !== APP_MESSAGES.POPUP_LOCALE_EDITOR) {
      return;
    }

    this.show(<ILocaleItem>appMessage.content);
  }


  private show(item: ILocaleItem) {
    this.item = item;
    $(this.element.nativeElement).modal("show");
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-locales-modal/nv-locales-modal.component.ts